import './theme_jytaksi.scss'
import ITheme from '../ITheme';

export default class ThemeJytaksi implements ITheme {
    id: string = "jytaksi";
    cssClassName: string = "theme_jytaksi";
    dark: boolean = false;
    menuDark: boolean = true;
    toolbarDark: boolean = true;
    menuRight: boolean = false;
    vuetifyTheme: any = {
        primary: '#E74793',
        secondary: '#00ff00',
        accent: '#ffcb31',
        warning: '#ffcb31'
    }
}
